import React from 'react'
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router';
const getStatusDotStyle = {
    height: "6px",
    width: "6px",
    borderRadius: "50%",
    display: "inline-block",
};
const getStatusTextWithColor = (status) => {
    let text = "";
    let color = "";

    switch (status) {
        case 2:
            text = "Live";
            color = "#4CAF50";
            break;
        case 0:
            text = "Completed";
            color = "#FF2626";
            break;
        case 1:
            text = "Upcoming";
            color = "#F38505";
            break;

    }

    return (
        <div>
            <span style={{ ...getStatusDotStyle, backgroundColor: color }}></span>
            <span style={{ marginLeft: "6px", color }}>{text}</span>
        </div>
    );
};
export default function useColumn() {
    const navigate = useNavigate()
    const columns = [
        { id: "Sl NO.", label: "Sl NO", renderCell: (_, index) => index + 1 },
        { id: "run_at", label: "Run At Time", renderCell: (row) => row?.run_at },
        { id: "Event Name ", label: "Event Name ", renderCell: (row) => row?.event?.name },
        { id: "Event ID ", label: "Event ID ", renderCell: (row) => row?.event?.handle },
        { id: "Total Packages ", label: "Total Packages ", renderCell: (row) => row?.package_ids.length },
        { id: "Event Status", label: "Event Status", renderCell: (row, index) => getStatusTextWithColor(row?.event.event_status) },
        { id: "Status", label: "Status", renderCell: (row, index) => row?.status },
        {
            id: "Action", label: "Action", renderCell: (row) => {
                return <IconButton
                    onClick={() => {
                        navigate("handle/", { state: row })
                    }}
                >
                    <EditIcon />
                </IconButton>
            }
        },
    ]
    return { columns }
}
